import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { SessionService } from '../services';
import { hasSessionHint } from '../utils/auth-hint';

export const authGuard: CanActivateFn = (_route, state) => {
  const session = inject(SessionService);
  const router = inject(Router);

  if (session.user) {
    return true;
  }

  if (session.authChecked || !hasSessionHint()) {
    return router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } });
  }

  return session.loadMe().pipe(
    map(() => true),
    catchError(() => of(router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } }))),
  );
};
